<template>
    <div class="configDiv">
        <div class="contentHeader">
            <div>
                <el-form :inline="true" ref="form" label-width="90px">
                    <el-row>
                        <el-col :span="3">
                            <el-button size="mini" @click="dialogEditConfigurationVisible=true">添加</el-button>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="环境：">
                                <el-select v-model="env" filterable placeholder="请选择">
                                    <el-option v-for="item in envOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="key：">
                                <el-select v-model="key" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in keysOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="application：">
                                <el-select v-model="application" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in applicationsOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="label：">
                                <el-select v-model="labelValue" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in labelsOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <el-table
                :data="tableData"
                style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="table-expand">
                        <el-form-item label="id：">
                            <span>{{ props.row.id }}</span>
                        </el-form-item>
                        <el-form-item label="application：">
                            <span>{{ props.row.application }}</span>
                        </el-form-item>
                        <el-form-item label="key：">
                            <span>{{ props.row.key }}</span>
                        </el-form-item>
                        <el-form-item label="label：">
                            <span>{{ props.row.label }}</span>
                        </el-form-item>
                        <el-form-item label="版本号：">
                            <span>{{ props.row.version }}</span>
                        </el-form-item>
                        <el-form-item label="环境：">
                            <span>{{ props.row.env }}</span>
                        </el-form-item>
                        <el-form-item label="创建时间：">
                            <span>{{ props.row.createdOn }}</span>
                        </el-form-item>
                        <el-form-item label="修改时间：">
                            <span>{{ props.row.modifiedOn }}</span>
                        </el-form-item>
                        <el-form-item label="value：">
                            <div v-if="props.row.value.length > 20">
                                <el-popover
                                        placement="top-start"
                                        width="600"
                                        trigger="hover"
                                        :content="props.row.value">
                                    <span slot="reference">{{props.row.value.substring(0, 20) + '...'}}</span>
                                </el-popover>
                            </div>
                            <div v-else>
                                <span>{{props.row.value}}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="state：">
                            <span>{{ props.row.state }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column
                    label="key"
                    prop="key">
            </el-table-column>
            <el-table-column
                    label="application"
                    prop="application">
            </el-table-column>
            <el-table-column
                    label="label"
                    prop="label">
            </el-table-column>
            <el-table-column
                    label="环境"
                    prop="env">
            </el-table-column>
            <el-table-column
                    label="version"
                    prop="version">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" @click="tableEdit(scope.row)">复制新增</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                :total="total"
                :current-page="pageNumber"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
        ></el-pagination>

        <el-dialog title="新增Configuration"
                   width="62%" :visible.sync="dialogEditConfigurationVisible" center
                   :close-on-click-modal="false"
                   @closed="dialogEditConfigurationClosedFn">
            <el-form label-position="right" label-width="110px" :rules="rules" :model="configurationFrom"
                     ref="configurationFrom">
                <el-form-item label="Key：" prop="key">
                    <el-select v-model="configurationFrom.key" filterable allow-create default-first-option clearable placeholder="请选择">
                        <el-option v-for="item in keysOptions" :key="item.value" :label="item.key"
                                   :disabled="item.disabled" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="value：" prop="value">
                    <el-input type="textarea" autosize v-model="configurationFrom.value" placeholder="请输入value"></el-input>
                </el-form-item>
                <el-form-item label="环境：" prop="env">
                    <el-select v-model="configurationFrom.env" filterable placeholder="请选择">
                        <el-option v-for="item in envOptions" :key="item.value" :label="item.key"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Application：" prop="application">
                    <el-select v-model="configurationFrom.application" filterable allow-create default-first-option clearable placeholder="请选择">
                        <el-option v-for="item in applicationsOptions" :key="item.value" :label="item.key"
                                   :disabled="item.disabled" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Label：" prop="label">
                    <el-select v-model="configurationFrom.label" filterable allow-create default-first-option clearable placeholder="请选择">
                        <el-option v-for="item in labelsOptions" :key="item.value" :label="item.key"
                                   :disabled="item.disabled" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="state：" prop="state">
                    <el-switch v-model="configurationFrom.state"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditConfigurationVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmButton('configurationFrom')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data: () => {
            let checkJson = (rule, value, callback) => {
                try {
                    if (typeof JSON.parse(value) == "object") {
                        callback();
                    }
                } catch (e) {
                }
                callback(new Error("请输入正确的json格式"));
            };
            return {
                tableData: [],
                pageSizes: [10, 20, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0,
                key: '', // 默认查找all
                application: '',
                labelValue: '',
                env: '', // 默认为dev环境
                keysOptions: [],
                applicationsOptions: [],
                labelsOptions: [],
                envOptions: [],
                dialogEditConfigurationVisible: false,
                configurationFrom: {
                    key: '',
                    value: '',
                    env: '',
                    application: '',
                    label: '',
                    state: false
                },
                rules: {
                    key: [
                        {required: true, message: '请选择key', trigger: 'blur'}
                    ],
                    value: [
                        {required: true, message: '请输入value', trigger: 'blur'},
                        {validator: checkJson, trigger: 'blur'}
                    ],
                    env: [
                        {required: true, message: '请选择环境', trigger: 'blur'}
                    ],
                    application: [
                        {required: true, message: '请选择application', trigger: 'blur'}
                    ],
                    label: [
                        {required: true, message: '请选择label', trigger: 'blur'}
                    ]
                }
            }
        },
        mounted: function () {
            this.getEnvOptions();
            if (this.env !== '') {
                this.getKeysOptions();
                this.getApplicationsOptions();
                this.getLabelsOptions();
                this.getTableData();
            }
        },
        watch: {
            env() {
                this.getKeysOptions();
                this.getApplicationsOptions();
                this.getLabelsOptions();
                this.getTableData();
            },
            key() {
                this.getTableData();
            },
            application() {
                this.getTableData();
            },
            labelValue() {
                this.getTableData();
            }
        },
        methods: {
            getTableData: function () {
                const self = this;
                let params = {};
                params.pageNum = self.pageNumber - 1;
                params.pageSize = self.pageSize;
                params.env = self.env;
                if (self.key !== '') {
                    params.key = self.key;
                }
                if (self.application !== '') {
                    params.application = self.application;
                }
                if (self.labelValue !== '') {
                    params.label = self.labelValue;
                }
                self.$axios_api.getConfigurationList(params).then(res => {
                    // 更新表格
                    self.tableData = res.rows;
                    for (let item in self.tableData) {
                        self.tableData[item].value = JSON.stringify(self.tableData[item].value, null, 4);
                    }
                    //更新分页总条数
                    self.total = res.total;
                });
            },
            //分页页码变化
            handleCurrentChange: function (pageNum) {
                this.pageNumber = pageNum;
                this.getTableData();
            },
            handleSizeChange: function (pageSize) {
                this.pageSize = pageSize;
                this.getTableData();
            },
            getKeysOptions: function () {
                let self = this;
                let params = {};
                params.env = self.env;
                self.$axios_api.getConfigurationKeys(params).then(res => {
                    self.keysOptions = res;
                });
            },
            getApplicationsOptions: function () {
                let self = this;
                let params = {};
                params.env = self.env;
                self.$axios_api.getConfigurationApplications(params).then(res => {
                    self.applicationsOptions = res;
                });
            },
            getLabelsOptions: function () {
                let self = this;
                let params = {};
                params.env = self.env;
                self.$axios_api.getConfigurationLabels(params).then(res => {
                    self.labelsOptions = res;
                });
            },
            getEnvOptions() {
                const self = this;
                let params = {};
                self.$axios_api.getEnvOptions(params).then(res => {
                    self.env = res.env_options[0].value;
                    self.envOptions = res.env_options;
                });
            },
            // 弹窗关闭按钮
            dialogEditConfigurationClosedFn: function () {
                this.configurationFrom.key = '';
                this.configurationFrom.value = '';
                this.configurationFrom.env = '';
                this.configurationFrom.application = '';
                this.configurationFrom.label = '';
                this.configurationFrom.state = false
            },
            confirmButton(configurationFrom) {
                this.$refs[configurationFrom].validate((valid) => {
                    if (valid) {
                        this.addConfigurationFn();
                    }
                });
            },
            addConfigurationFn: function () {
                const self = this;
                let params = {};
                params.key = self.configurationFrom.key;
                params.env = self.configurationFrom.env;
                params.value = JSON.parse(self.configurationFrom.value);
                params.application = self.configurationFrom.application;
                params.label = self.configurationFrom.label;
                params.state = self.configurationFrom.state;
                if (params.state === false) {
                    self.$message({
                        message: 'state必须为true',
                        type: 'warning'
                    })
                } else {
                    let data = JSON.stringify(params);
                    self.$axios_api.saveConfiguration(data).then(res => {
                        self.$message({
                            message: res,
                            type: 'success'
                        });
                        self.dialogEditConfigurationVisible = false;
                        self.getTableData();
                    })
                }
            },

            tableEdit: function (row) {
                const self = this;
                this.configurationFrom.key = row.key;
                this.configurationFrom.env = row.env;
                this.configurationFrom.value = row.value;
                this.configurationFrom.application = row.application;
                this.configurationFrom.label = row.label;
                this.configurationFrom.state = row.state;
                self.dialogEditConfigurationVisible = true;
            }
        },
    };
</script>

<style scoped>
    .table-expand {
        font-size: 0;
    }

    .table-expand label {
        width: 100px;
        color: #99a9bf;
        float: left;
    }

    .table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
</style>